const Languages = [
  {
    name: 'Japanese',
    id: 'ja',
  },
  {
    name: 'Chinese',
    id: 'zh',
  },
  {
    name: 'Korean',
    id: 'ko',
  },
  {
    name: 'Thai',
    id: 'th',
  },
]

export default Languages
